import { render } from "./IndisposList.vue?vue&type=template&id=6913f425"
import script from "./IndisposList.vue?vue&type=script&lang=ts"
export * from "./IndisposList.vue?vue&type=script&lang=ts"
script.render = render

export default script